import { render } from "./SolucaoFornecedorContratacaoForm.vue?vue&type=template&id=a514aade"
import script from "./SolucaoFornecedorContratacaoForm.vue?vue&type=script&lang=js"
export * from "./SolucaoFornecedorContratacaoForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__